import {
  DELETE_CONTENT_OR_FOLDER_SUCCESS,
  FAVORITE_CONTENT_FULFILLED,
  GET_USER_REQUESTED,
  GET_USER_REQUEST_FULFILLED,
  GET_USER_REQUEST_REJECTED,
  SEARCH_MOST_RECENT_COMPONENTS_FULFILLED,
  SEARCH_MOST_RECENT_COMPONENTS_REJECTED
} from './const';

/**
 * trigger a request to get user data
 * @returns {object} an action object
 */
export const getUserRequest = () => ({
  type: GET_USER_REQUESTED
});

/**
 * handle get user request failure
 * @param {Error} error - the error object describing the failure
 * @returns {object} an action object
 */
export const getUserFailure = error => ({
  type: GET_USER_REQUEST_REJECTED,
  error
});

/**
 * handle get user request success
 * @param {object} payload - the response payload of the successful call
 * @returns {object} an action object
 */
export const getUserSuccess = payload => ({
  type: GET_USER_REQUEST_FULFILLED,
  payload
});

/**
 * sets most recent components in redux state
 * @param {object} response - response from api call
 * @returns {object} an action object
 */
export const mostRecentComponentsSuccess = response => ({
  type: SEARCH_MOST_RECENT_COMPONENTS_FULFILLED,
  response
});

/**
 * most resent components api called failed
 * @param {Error} error - the error object describing the failure
 * @returns {object} an action object
 */
export const mostRecentComponentsFailure = error => ({
  type: SEARCH_MOST_RECENT_COMPONENTS_REJECTED,
  error
});

/**
 * favorite/unfavorite success
 * @param {Array} favorites - array of favorite content
 * @returns {object} an action object to update favorite content in store
 */
export const favoriteContentSuccess = favorites => ({
  type: FAVORITE_CONTENT_FULFILLED,
  favorites
});

/**
 * delete from favorite/unfavorite, mostrecent, search & folder content in store
 * @param {string} context - content type
 * @param {string} contentId - contentId to be deleted
 * @param {string} parentId - parent Id of the content
 * @returns {object} an action object to update favorite content in store
 */
export const clearContentOrFolderInStore = (context, contentId, parentId = undefined) => ({
  type: DELETE_CONTENT_OR_FOLDER_SUCCESS,
  context,
  contentId,
  parentId
});
